// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__1dsM8","messages":"Chat_messages__15mIJ","dateDivider":"Chat_dateDivider__3IbAA"};